export const currency = (value: number) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(value);

export const number = (value: number) => new Intl.NumberFormat("en-US").format(value);

export const countdown = (seconds: number) => {
  const safe = Math.max(seconds, 0);
  const days = Math.floor(safe / 86400);
  const hours = Math.floor((safe % 86400) / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  if (days) return `${days}d ${hours}h`;
  return `${hours}h ${minutes}m`;
};

export const maskVin = (vin: string) => `${vin.slice(0, 8)}...${vin.slice(-4)}`;
